import _ from 'lodash';
import React from 'react';
import * as Styled from './styled';
import navBarTestIds from '../NavigationMenu.elements';

type SubMenuItemProps = {
	title: string;
	relativePath: string;
	absolutePath?: string;
	tabIndex: Number;
	parentIdentifier: string;
};

const NavigationSubMenuItem: React.FunctionComponent<
	SubMenuItemProps
> = props => {
	const { title, relativePath, absolutePath } = props;
	// const linkRef = React.useRef<HTMLAnchorElement>(null);

	const Link = relativePath ? Styled.RouterLink : Styled.AnchorLink;
	const path = relativePath || (absolutePath as string);

	return (
		<Styled.Li>
			{/*
			// @ts-ignore */}
			<Link
				{...{ [relativePath ? 'to' : 'href']: path }}
				// ref={linkRef}
				data-id={navBarTestIds.subMenuItems}
				data-analytics-id={`${props.parentIdentifier}>${_.kebabCase(title)}`}
			>
				<Styled.LinkText variant="button">{title}</Styled.LinkText>
			</Link>
		</Styled.Li>
	);
};

export default NavigationSubMenuItem;
